import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['expandLink', 'expandedContent'];

  connect() {
    if (!this.data.has('is-expanded')) {
      this.isExpanded = false;
    }
  }

  toggleExpanded(event) {
    event && event.preventDefault();
    this.isExpanded ? this.close() : this.expand();
  }

  expandIfClosed() {
    if (!this.isExpanded) this.expand();
  }

  close() {
    this.isExpanded = false;
  }

  //
  // INTERNAL USE
  //

  expand() {
    // For now, just always fetch data.  If needed, we can add logic to determine if it has already been fetched.
    this.isExpanded = true;
    this.expandedContent = App.spinner();
    xhrRequest(this.url, 'get').then(({ data }) => this.expandedContent = data);
  }

  //
  // GETTERS AND SETTERS
  //

  get isExpanded() {
    return ['1', true, 'true'].indexOf(this.data.get('is-expanded')) > -1;
  }

  set isExpanded(val) {
    this.data.set('is-expanded', val);
    this.expandLinkTarget.innerHTML = this.isExpanded ? this.collapseContent : this.expandContent;
    this.hasExpandedContentTarget && this.expandedContentTarget.classList[this.isExpanded ? 'add' : 'remove']('expanded');
  }

  set expandedContent(content) {
    this.hasExpandedContentTarget && (this.expandedContentTarget.innerHTML = content);
  }

  get url() {
    return App.Helpers.addParamsToURL(this.data.get('expand-url'), { status: this.data.get('activity-status') });
  }

  get expandContent() {
    return 'Expand <i class="fas fa-caret-down"></i>';
  }

  get collapseContent() {
    return 'Collapse <i class="fas fa-caret-up"></i>';
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/involvement/involvement-campaign-controller.js